module.exports = __webpack_public_path__ + "static/media/dropIcon.478c2ab4.svg";